import React from 'react';
import PropTypes from 'prop-types';

import ResourceWeeklySchedule from '../ResourceSchedule/ResourceWeeklySchedule';
import equipmentAxis from './equipmentAxis';
import useEquipmentRows from './useEquipmentRows';

export default function EquipmentWeeklySchedule({ filters, ...props }) {
  const rows = useEquipmentRows({ filters });
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <ResourceWeeklySchedule axis={equipmentAxis} rows={rows} {...props} />
  );
}

EquipmentWeeklySchedule.propTypes = {
  filters: PropTypes.shape({
    equipment: PropTypes.arrayOf(PropTypes.string),
    equipmentTypes: PropTypes.arrayOf(PropTypes.string),
  }),
};

EquipmentWeeklySchedule.defaultProps = {
  filters: {},
};
